import { type FC } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { formatCurrency } from "@/lib/utils";
import { Users2Icon, DollarSignIcon, PercentIcon, ClockIcon } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

interface MetricsCardsProps {
  metrics: {
    active_partners: number;
    total_earnings: number;
    conversion_rate: number;
    pending_payments: number;
  };
  loading?: boolean;
}

export const MetricsCards: FC<MetricsCardsProps> = ({ metrics, loading = false }) => {
  const cards = [
    {
      title: "Socios Activos",
      value: metrics.active_partners,
      icon: Users2Icon,
      description: "Total de socios activos",
    },
    {
      title: "Ganancias Totales",
      value: formatCurrency(metrics.total_earnings),
      icon: DollarSignIcon,
      description: "Ganancias totales generadas",
    },
    {
      title: "Tasa de Conversión",
      value: `${metrics.conversion_rate}%`,
      icon: PercentIcon,
      description: "Promedio de conversión",
    },
    {
      title: "Pagos Pendientes",
      value: formatCurrency(metrics.pending_payments),
      icon: ClockIcon,
      description: "Total de pagos pendientes",
    },
  ];

  if (loading) {
    return (
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => (
          <Skeleton key={i} className="h-32" />
        ))}
      </div>
    );
  }

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {cards.map((card, i) => {
        const Icon = card.icon;
        return (
          <Card key={i}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">
                {card.title}
              </CardTitle>
              <Icon className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">{card.value}</div>
              <p className="text-xs text-muted-foreground">
                {card.description}
              </p>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};
